/**
 * Utilidades de VLAN por puerto de switch.
 *
 * El campo `vlan` de un puerto de switch es texto libre y admite las dos
 * notaciones habituales de configuración:
 *
 *   - `access 120`            → el puerto pertenece a una única VLAN (dato).
 *   - `trunk 110,120,130,150` → el puerto transporta varias VLANs etiquetadas
 *                               (normalmente hacia otro switch o un firewall).
 *
 * Se usan en el mapa de puertos (PortMapModal) y en la pestaña de puertos del
 * formulario (SwitchPortsTab) para pintar un resumen compacto en la casilla.
 */

/** ¿El puerto es un enlace trunk (varias VLANs etiquetadas)? */
export function vlanIsTrunk(vlan) {
  return /^trunk\b/i.test(String(vlan || '').trim());
}

/**
 * Resumen compacto para la casilla del puerto.
 *
 * Devuelve `{ label, trunk }` o `null` si el valor almacenado no es una
 * notación de VLAN reconocible (p. ej. etiquetas heredadas como "DATA"), para
 * no hacer pasar por VLAN algo que no lo es. El valor original siempre está
 * disponible en el tooltip.
 *
 *   `access 120`             → { label: 'V120', trunk: false }
 *   `trunk 110,120,130,150`  → { label: 'TRK',  trunk: true  }
 *   `120`                    → { label: '120',  trunk: false }
 *   `DATA`                   → null
 */
export function vlanChip(vlan) {
  const raw = String(vlan || '').trim();
  if (!raw) return null;
  const access = /^access\s+(\d+)/i.exec(raw);
  if (access) return { label: `V${access[1]}`, trunk: false };
  if (vlanIsTrunk(raw)) return { label: 'TRK', trunk: true };
  if (/^\d+$/.test(raw)) return { label: raw, trunk: false };
  return null;
}

/** Texto completo para el tooltip: `VLAN del puerto: access 120`. */
export function vlanTitle(vlan) {
  const raw = String(vlan || '').trim();
  return raw ? `VLAN del puerto: ${raw}` : '';
}
